var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.1111L14 14L11.2 11.2778L12.4 10.1111L14 11.6667L16.8 8.94444L18 10.1111ZM9.6 10.8889H1.6V3.11111L8 7L14.4 3.11111V7H16V1.55556C16 0.7 15.28 0 14.4 0H1.6C0.72 0 0 0.7 0 1.55556V10.8889C0 11.7444 0.72 12.4444 1.6 12.4444H9.6V10.8889ZM14.4 1.55556L8 5.44444L1.6 1.55556H14.4Z",
    fill: "#6E6E73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.23bedacfa56ad721ba7171913b8a7048.svg";
export { ForwardRef as ReactComponent };